module.exports = __webpack_public_path__ + "static/media/primitive.b4c2bee8.jpg";